import { Prec } from '@codemirror/state'
import { EditorView, keymap } from '@codemirror/view'
import { acceptCompletion, completionStatus } from '@codemirror/autocomplete'

export const tabAcceptsCompletion = Prec.highest(keymap.of([{ key: 'Tab', run: acceptCompletion }]))

// Claim Cmd/Ctrl+Enter ahead of defaultKeymap, which binds it to insertBlankLine, for editors
// whose wrapper commits on that shortcut (the JSON cell). Returning true makes CodeMirror call
// preventDefault but not stopPropagation, so the keydown still reaches the wrapper's handler.
export const claimModEnter = Prec.highest(keymap.of([{ key: 'Mod-Enter', run: () => true }]))

// Keep Escape from bubbling to ancestor `document` listeners (e.g. the column-options
// Menu that closes itself on Escape) while the autocomplete popup is open. Must run at
// Prec.highest so it fires before the autocomplete keymap claims the event (CodeMirror
// breaks out of its handler loop as soon as a handler returns true). We return false so
// the autocomplete keymap still runs and closes the popup — we only stop the event from
// reaching the ancestor document listener.
export const containEscapeWhenCompletionOpen = Prec.highest(
  EditorView.domEventHandlers({
    keydown: (event, view) => {
      if (event.key === 'Escape' && completionStatus(view.state) !== null) {
        event.stopPropagation()
      }
      return false
    }
  })
)
